import { useEffect } from 'react';

/**
 * Hook to control the header z-index when a modal is opened
 * Dispatches 'alea-global-modal-open' event that the Header component listens to
 * 
 * @param isOpen - Whether the modal is currently open
 */
const useModalHeaderZIndex = (isOpen: boolean) => {
  useEffect(() => {
    try {
      const ev = new CustomEvent('alea-global-modal-open', { detail: isOpen });
      window.dispatchEvent(ev);
    } catch (error) {
      console.error('Error dispatching global modal event:', error);
    }
    
    return () => {
      try {
        const ev = new CustomEvent('alea-global-modal-open', { detail: false });
        window.dispatchEvent(ev);
      } catch (error) {
        console.error('Error dispatching global modal close event:', error);
      }
    };
  }, [isOpen]);
};

export default useModalHeaderZIndex;

